'use client'

import { useMemo, useState, useEffect } from 'react'
import { useGetAbApiDataQuery } from '@/src/api/rtkQuery/abApi'
import { getAbFromCookie } from '@/src/utils/abConfig/cookieUtils'
import { getFetchControl } from '@/src/utils/abConfig'
import { isCleartrip } from '@/src/utils/generalUtils/isCleartrip'
import { isInternalUser } from '@/src/utils/generalUtils/checkUserLogin'

export interface UseAbConfigResult {
    isMultiBrand: boolean | undefined
}

export const useAbConfig = (): UseAbConfigResult => {
    const { data: abApiData } = useGetAbApiDataQuery()
    const isCleartripBrand = isCleartrip()
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    const isMultiBrand = useMemo(() => {
        if (!isMounted) return undefined
        const forceMultiBrandForInternalUser = isInternalUser()
        const config = abApiData?.bff !== undefined ? abApiData : getAbFromCookie()
        return getFetchControl(isCleartripBrand, config, forceMultiBrandForInternalUser) === 'ALL'
    }, [abApiData, isCleartripBrand, isMounted])

    return { isMultiBrand }
}

export default useAbConfig
